export default __webpack_public_path__ + "static/media/Ct2.5239eeb3.png";